import { Button } from '@material-ui/core';
import { useEffect } from 'react';
import en from '../../../../lang/en-us';
const { dashboard } = en;

export default function PostTransmissionSuccess(props: any) {
    const { reqId = '' } = props.location.state || {};

    useEffect(() => {
        if (!reqId) {
            props.history.push('/');
        }
    }, []);
    return (
        <div className="curved-bg">
            <h2 className="heading">
                <a onClick={() => props.history.push('/portal/nct')}>
                    <img src="/images/left-arrow-black.svg" alt="icon" />
                </a>
                {dashboard.TransmissionRequest.success.back}
            </h2>
            <div className="curved-bg-content nct-success-screen transmission-success">
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <img
                            className="change-email-img"
                            src="/images/portfolio-banner-character.png"
                            alt="icon"
                        />
                        <h3 className="subheading">
                            {dashboard.TransmissionRequest.success.success}
                        </h3>
                        <p>
                            {dashboard.TransmissionRequest.success.info1}
                            <span>"{reqId}"</span>
                            {dashboard.TransmissionRequest.success.info2}
                        </p>
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <p>{dashboard.TransmissionRequest.success.submitFormInfo}</p>
                    </div>
                    <div
                        className="curved-bg-content-inner-bottom"
                        style={{ flexDirection: 'row', justifyContent: 'center' }}
                    >
                        <Button
                            className="customBtn"
                            onClick={() => props.history.push(`/portal/track-for-nct/${reqId}`)}
                        >
                            {dashboard.changeEmail.Success.buttonText}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
